<template>
  <picker-field :label="label" :value="value" :isNeedInput="isNeedInput" title="选择联系人" @onchange="onchange" ref="picker" @open="onSearch">
    <div class="list">
      <div class="weui-cells">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          @click="select(item)"
        >
          <div class="weui-cell__bd">
            <p>{{item.cc_name}}</p>
          </div>
          <div class="weui-cell__ft"></div>
        </div>
      </div>
    </div>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";

export default {
  components: {
    PickerField
  },
  props: {
    label: {
      type: String,
      default: "联系人"
    },
    value: String,
    customerId: Number,
    isNeedInput: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      items: []
    };
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.cc_name);
      me.$emit("select", item);
      me.$refs.picker.close();
    },
    onchange(value) {
      var me = this
      me.$emit("onchange", value);
    },
    onSearch() {
      var me = this;
      if(me.customerId) {
        me.$loading({
          url: "/api/document/customer/custcontacts",
          params: {
            condition: JSON.stringify([{"type":"condition","value":"cc_cuid=" + me.customerId}])
          }
        }).then(function(res) {
          if (res.success) {
            me.items = res.data.list;
          } else {
            me.$weui.topTips(res.message, 2000);
          }
        });
      }
    },
  }
};
</script>